/*
 *
 */
import {Injectable} from '@angular/core';
import {BaseHubService} from './base-hub.service';
import {Avancement, IAvancement} from '../../_models/Avancement';
import {HttpClient} from '@angular/common/http';
import {MessageService} from '../local/message.service';
import {ConfigService} from '../local/config.service';
import {Store} from '@ngrx/store';
import {MainStoreState} from '../../_store/mainStoreState';
import {setAvancementsAction} from '../../_store/AvancementStore/avancement.store';
import {IBaseObject} from 'src/app/_models/BaseObject';

@Injectable({
  providedIn: 'root',
})
export class AvancementService extends BaseHubService<Avancement> {
  constructor(
    http: HttpClient,
    messageService: MessageService,
    configService: ConfigService,
    private store: Store<MainStoreState>
  ) {
    super(
      'sous-systemes/avancement',
      'hubs/avancementsHub',
      'Avancements',
      http,
      messageService,
      configService
    );
  }

  refreshHubConnection(): Promise<void> {
    return this.start();
  }

  protected dispatchUpdateData(data: IBaseObject[]): void {
    this.store.dispatch(
      setAvancementsAction({payload: data as IAvancement[]})
    );
  }
}
